<template>
  <div class="faq bg--color-02 flx--grow-1 pb-48 pb-100--l pt-32 pt-48--l">
    <div class="container-new">
      <h1
        class="txt--bold txt--color-04 txt--36px txt--52px--l txt--height-44px txt--height-64px--l mb-28 mb-30--l"
      >
        FAQ
      </h1>

      <div v-if="loading" class="pt-20">
        <exc-loader class="txt--main txt--center" />
      </div>

      <faq-list
        v-else
        :items="faqs"
        class="mt-40"
        @update-items="fetchFaqItems"
      />
    </div>
  </div>
</template>

<script>
import { ExcLoader } from '@/components/common'
import { mapActions, mapGetters } from 'vuex'
import { getDefaultHeadData } from '@/lib/utils'

export default {
  name: 'FAQ',
  components: {
    ExcLoader,
    FaqList: () =>
      import(/* webpackMode: "eager" */ '@/components/faq/FaqList.vue'),
  },
  data () {
    return {
      loading: true,
    }
  },
  head () {
    return getDefaultHeadData({
      title: this.$t('meta.faq.title'),
      description: this.$t('meta.faq.description'),
      locale: this.$i18n.locale,
    })
  },
  computed: {
    ...mapGetters('faq', ['getFaqs']),
    faqs () {
      return this.getFaqs()
    },
  },
  created () {
    if (!process.client) return

    this.fetchFaqItems().finally(() => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions({
      fetchFaqItems: 'faq/actionGetFaq',
    }),
  },
}
</script>
